import React, { useState ,useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StockListLayer from "../components/StockListLayer";
import { API_URL, LOCATION_ID } from "..";
import { Spinner } from "react-bootstrap";
import SupplierListLayer from "../components/SupplierListLayer";




const SupplierListPage = () => {

  const [data, setData]=useState([])
  const [loading, setLoading]=useState(false)
  const fetchSuppliers =  async()=>{
     const locationId = localStorage.getItem('locationID')
    setLoading(true)
      const user = JSON.parse(localStorage.getItem('user'));
      if(!user){
        window.location.href='/sign-in'
      }else{
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
        let response = await fetch( API_URL+`/api/suppliers/?locationId=${locationId}`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        console.log(data);
        setLoading(false)
        // console.log(data)
        setData(data.suppliers)
      }
      
  }
  useEffect(()=>{
    fetchSuppliers();
  },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Suppliers - List" />

        {/* InvoiceListLayer */}
        {
          loading ===true ?
          <div className="text-center mt-4">
            <Spinner/>
          </div>:null
        }
        {
          data?.length === 0 && loading ===false ?
          <div className="text-center mt-4">
            <p>No Supplier data found....</p>
          </div>:null
        }
        {
          data?.length== 0 ? null :
          <SupplierListLayer suppliersData={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default SupplierListPage;
